"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FilteringService = void 0;
/* eslint-disable no-continue */
const core_1 = require("@angular/core");
let FilteringService = class FilteringService {
    /**
     * Filters the provided dataset. Traverses through each entry of the provided dataset
     * and checks if it is matched by all the supplied filters.
     */
    filterDataset(dataset, filters) {
        return dataset.filter((o) => {
            for (const [filterId, filter] of Object.entries(filters)) {
                if (!filter)
                    continue;
                const filterValue = filter.value;
                if (!filterValue)
                    continue;
                try {
                    // eslint-disable-next-line max-len
                    const traversals = Array.isArray(filter.traversal) ? filter.traversal : [filter.traversal];
                    let matchesFilter = false;
                    traversals.forEach((t) => {
                        let valueOfO = '';
                        try {
                            valueOfO = t
                                .split('.')
                                .reduce((e, i) => e[i], o);
                        }
                        catch (e) {
                            valueOfO = '';
                        }
                        if (filterValue === 'NOT_DEFINED' && !valueOfO) {
                            matchesFilter = true;
                            return true;
                        }
                        if (filterValue === 'NOT_DEFINED' && valueOfO)
                            return false;
                        if (filterValue === 'DEFINED' && valueOfO) {
                            matchesFilter = true;
                            return true;
                        }
                        if (filterValue === 'DEFINED' && !valueOfO)
                            return false;
                        if (valueOfO === null || valueOfO === undefined)
                            return false;
                        /**
                         * 'BOOLEAN_OBJECT' filter: The filter's value represents one ore more keys for a
                         * boolean
                         * attribute of the filtered data. All boolean values have to be true
                         * to be included in the results.
                         *
                         * 'ARRAY_OBJECT' filter: The filter's value represents an array of objects
                         * The 'objectKey' property is therefore required to get the object's value
                         * to run the filter against.
                         *
                         * Example:
                         * filter value: 'bluetooth, androidAuto'
                         * traversal: 'modelData.infotainment'.
                         *
                         * The `infotainment` object must include the attributes `bluetooth` and `androidAuto`
                         * and they both have to be true.
                         */
                        if (filter.type === 'BOOLEAN_OBJECT') {
                            matchesFilter = filterValue
                                .replace(/ /g, '')
                                .split(',')
                                .map((key) => valueOfO[key] === true)
                                .filter((s) => !s)
                                .length === 0;
                        }
                        else if (filter.type === 'ARRAY_OBJECT' && filter.objectKey) {
                            let matchesAnyFilter = true;
                            filterValue.replace(/ /g, '').split(',').forEach((f) => {
                                const matchesThisFilter = valueOfO
                                    .some((v) => String(v[filter.objectKey])
                                    .toLowerCase() === f.toLowerCase());
                                if (!matchesThisFilter)
                                    matchesAnyFilter = false;
                            });
                            matchesFilter = matchesAnyFilter;
                        }
                        else {
                            filterValue.replace(/ /g, '').split(',').forEach((f) => {
                                if (typeof valueOfO === 'string') {
                                    if (valueOfO.replace(/ /g, '').toLowerCase().includes(f.toLowerCase())) {
                                        matchesFilter = true;
                                    }
                                }
                                if (typeof valueOfO === 'number') {
                                    if (String(valueOfO) === f)
                                        matchesFilter = true;
                                }
                            });
                        }
                    });
                    if (!matchesFilter)
                        return false;
                }
                catch (e) {
                    if (filterValue === 'NOT_DEFINED')
                        return true;
                    return false;
                    continue;
                }
            }
            return true;
        });
    }
};
FilteringService = __decorate([
    (0, core_1.Injectable)()
], FilteringService);
exports.FilteringService = FilteringService;
